import { useState } from "react";
import styles from "./ForgotPwModal.module.css";
import axios from "axios";
import { DEV_API } from "../Common/Constant";

const ForgotPWModal = ({ toggleForgetPswd }) => {
  const [loginErr, updateLoginError] = useState("");
  const [successRes, updateSuccessRes] = useState("");
  const [formData, setFormData] = useState({
    email: "",
  });
  const [isLoading, setLoading] = useState(false);

  const onFormSubmit = (e) => {
    e.preventDefault();
    const req = structuredClone(formData);
    setLoading(true);
    axios
      .post(`${DEV_API}/users/forgot-password`, req)
      .then((res) => {
        updateSuccessRes("Link sent to your mail id");
      })
      .catch((err) => {
        console.error("err----", err?.response?.data?.error);
        updateLoginError(err?.response?.data?.error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <h2 className="m0">Forgot Password</h2>
          <form
            id="forgotPwForm"
            onSubmit={onFormSubmit}
            className={styles.form}
          >
            <div className={styles.formGroup}>
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            {successRes && (
              <div className={styles.successRes}>{successRes}</div>
            )}
            {loginErr && <div className={styles.loginError}>{loginErr}</div>}
          </form>

          <div className={styles.footer}>
            {!successRes && (
              <button
                form="forgotPwForm"
                type="submit"
                className={`${styles.submitButton} ${styles.btn}`}
                disabled={isLoading}
              >
                Submit
              </button>
            )}
            <button
              className={`${styles.secondaryBtn} ${styles.btn}`}
              onClick={toggleForgetPswd}
            >
              {successRes ? 'Close' : 'Cancel'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPWModal;
